import { fetchJSON as fetchAPI } from './client';

export type ReadinessDashboardSnapshot = {
  tenant_id: string; overall_score: number; integration_score: number;
  journey_pass_rate: number; critical_bugs: number; open_security_findings: number;
  release_candidate: string; pilot_ready: boolean; generated_at: string;
};

export type IntegrationPoint = {
  key: string; name: string; service: string; interface: string;
  status: string; last_checked?: string;
};

export type BusinessJourney = {
  key: string; name: string; category: string; steps: string[];
  status: string; pass_rate_pct: number;
};

export type ReadinessReport = {
  type: string; title: string; status: string; score: number;
  summary: string; findings?: { key: string; severity: string; title: string; status: string }[];
  generated_at: string;
};

export type GoNoGoItem = {
  key: string; criterion: string; status: string; blocking: boolean; owner?: string;
};

export type RiskItem = { id: string; title: string; severity: string; mitigation?: string; status: string };
export type ChecklistItem = { key: string; title: string; completed: boolean; category: string };
export type PRTTimelineEvent = { id: string; type: string; title: string; actor: string; timestamp: string };

const COMMAND_BASE = import.meta.env.VITE_COMMANDCENTER_API ?? '/api/v1/command';
const fetchC = <T,>(path: string, init?: RequestInit) => fetchAPI<T>(`${COMMAND_BASE}${path}`, init);

export const productionReadinessApi = {
  dashboard: () => fetchC<ReadinessDashboardSnapshot>('/production-readiness/dashboard'),
  integration: () => fetchC<{ integration_points: IntegrationPoint[] }>('/production-readiness/integration').then((r) => r.integration_points),
  journeys: () => fetchC<{ journeys: BusinessJourney[] }>('/production-readiness/journeys').then((r) => r.journeys),
  report: (type: string) => fetchC<ReadinessReport>(`/production-readiness/reports/${type}`),
  goNoGo: () => fetchC<{ items: GoNoGoItem[] }>('/production-readiness/go-nogo').then((r) => r.items),
  riskRegister: () => fetchC<{ risks: RiskItem[] }>('/production-readiness/risk-register').then((r) => r.risks),
  releaseChecklist: () => fetchC<{ checklist: ChecklistItem[] }>('/production-readiness/release-checklist').then((r) => r.checklist),
  history: () => fetchC<{ events: PRTTimelineEvent[] }>('/production-readiness/history').then((r) => r.events),
  search: (query: string) =>
    fetchC<{ results: { id: string; type: string; title: string; summary?: string }[] }>('/production-readiness/search', {
      method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ query }),
    }).then((r) => r.results),
};
